import { createAction } from '@reduxjs/toolkit';

export const CHANGE_SIDEBAR_TABKEY = 'CHANGE_SIDEBAR_TABKEY';

export const changeSidebarTabKey = createAction(CHANGE_SIDEBAR_TABKEY);
